import { DEFAULT_USER_CONFIG } from '../config/user';
export const getBestAMMTradeOpts = (from, to, userConfig = {}) => {
    return {
        ...DEFAULT_USER_CONFIG,
        ...userConfig,
        from,
        to,
        amount: from.amount,
    };
};
